import cn from 'classnames';
import { useSegmentationContext } from 'contexts/segmentation';
import { EntryNavigationItem } from 'interfaces/navigation-data';
import NextLink from 'next/link';
import { FC, PropsWithChildren } from 'react';
import { useRootStore } from 'stores/use-root-store';
import { getSegmentationFromUrl } from 'utils/url/get-segmentation-from-url';

interface ILinkProps {
  as?: string;
  className?: string;
  item: EntryNavigationItem;
  onClick?: () => void;
}
/**
 * Link component used in the desktop navigation
 */
const Link: FC<PropsWithChildren<ILinkProps>> = ({ as, children, className, item, onClick }) => {
  const petType = useRootStore((store) => store.petType);
  const { pushSegmentation } = useSegmentationContext();

  const onLinkClick = (item: EntryNavigationItem): void => {
    if (item.itemType === 'entry' || item.itemType === 'card') {
      const segmentation = getSegmentationFromUrl({
        path: item.url, // itm url is actually relative path
      });
      if (segmentation) {
        pushSegmentation({
          segmentation: segmentation.id,
          isUserAction: true,
        });
      }
      onClick?.();
    }
  };

  return (
    <NextLink
      passHref
      href={item.url}
      as={as}
      data-test={`nav-${petType}-${item.title}`}
      className={cn(
        'text-primary-main hover:text-other-black relative flex h-10 items-center px-2 pb-px text-sm font-medium',
        className
      )}
      onClick={() => onLinkClick(item)}
    >
      {children}
    </NextLink>
  );
};

export default Link;
